import modules from 'src/store/modules';
import { createStore } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Object.entries(modules).forEach(([name, mod]) => {
  if (!mod) {
    // eslint-disable-next-line no-console
    console.error(
      `[store] Module "${name}" is undefined. Check its export/import path.`
    );
  }
});

export default createStore({
  state() {
    return {
      spinner: false,
      sidebar: false,
      theme: true,
      currentRoute: [],
      currentObject: null,
      isTourRunning: false,
      routeDetail: {
        prevRouter: null,
        nextRoute: null,
      },
      taskId: null,
      prevMetaData: null,
      // frameStepSize: 10,
      totalFrames: 0,
    };
  },

  getters: getters,
  mutations: mutations,
  actions: actions,

  modules: {
    ...modules,
  },
});
